import * as React from 'react';
import * as moment from 'moment';
import { Reservation } from '../../../../../api/TourSignup';

interface Props {
    reservation: Reservation;
}

const ReservationDisplay = (props: Props) => (
    <div>
        <span>
            {`${moment(props.reservation.event.startDateTime).format('dddd, MMMM D')}`}
            <br />
            {`${moment(props.reservation.event.startDateTime).format('h:mm A')} to 
                            ${moment(props.reservation.event.endDateTime).format('h:mm A')}`}
        </span>
    </div>
);

export default ReservationDisplay;



// WEBPACK FOOTER //
// ./src/components/pages/prospect/signup/display/ReservationDisplay.tsx